//
//
//
//
//
//
//
//
//
//
//
//

import KickboxingAboveTheFold from '~/components/kickboxing/Kickboxing_AboveTheFold.vue';
import KickboxingDetails from '~/components/kickboxing/Kickboxing_Details2.vue';
import KickboxingWorkouts from '~/components/kickboxing/Kickboxing_Workouts.vue';
import KickboxingWorks from '~/components/kickboxing/Kickboxing_Works.vue';
import KickboxingImgVidSections from '~/components/kickboxing/Kickboxing_Img_Vid_Sections.vue';
import KickboxingTrainers from '~/components/kickboxing/Kickboxing_Trainers.vue';
import KickboxingCTA from '~/components/kickboxing/Kickboxing_CTA.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Kickboxing',
  head: {
    ...metaData.kickboxing,
  },
  components: {
    KickboxingAboveTheFold,
    KickboxingTrainers,
    KickboxingDetails,
    KickboxingWorkouts,
    KickboxingWorks,
    KickboxingImgVidSections,
    KickboxingCTA,
  },
};
